module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faste-tillaeg text-dark"
  }, [_c('h2', {
    staticClass: "marg-1-bottom capitalize"
  }, [_vm._v("Faste tillæg")]), _vm._v(" "), _c('div', {
    staticClass: "faste-tillaeg__header"
  }, [_c('div', {
    staticClass: "faste-tillaeg__header__left"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.viewTabs,
      "selected": _vm.viewTab
    },
    on: {
      "select": _vm.onSelectViewTab
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Personer',
      "tags": _vm.personNames,
      "selectedTags": _vm.selectedNames,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg personer'
    },
    on: {
      "select": _vm.toggleName,
      "clear": function($event) {
        _vm.selectedNames = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Grupper',
      "tags": _vm.tags,
      "selectedTags": _vm.selectedTags,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg grupper'
    },
    on: {
      "select": _vm.toggleTag,
      "clear": function($event) {
        _vm.selectedTags = []
      }
    }
  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Ansættelser',
      "tags": _vm.employmentTitles,
      "selectedTags": _vm.selectedEmploymentTitles,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg stilling'
    },
    on: {
      "select": _vm.toggleEmploymentTitle,
      "clear": function($event) {
        _vm.selectedEmploymentTitles = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Organisationer',
      "tags": _vm.organisations,
      "selectedTags": _vm.selectedOrganisations,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg organisation'
    },
    on: {
      "select": _vm.toggleOrganisation,
      "clear": function($event) {
        _vm.selectedOrganisations = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewTab === 'opus') ? _c('span', {
    staticClass: "faste-tillaeg__count"
  }, [_vm._v("\n        Viser " + _vm._s(_vm.filteredRows.length) + " af " + _vm._s(_vm.allRows.length) + " ansættelser\n      ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.viewTab === 'opus') ? _c('div', {
    staticClass: "faste-tillaeg__toolbar"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'top',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window'
      }),
      expression: "{\n            arrow: true,\n            placement: 'top',\n            animateFill: false,\n            animation: 'shift-away',\n            boundary: 'window'\n          }"
    }],
    staticClass: "faste-tillaeg__toolbar__wrap",
    attrs: {
      "content": _vm.selectedEmploymentIds.length === 0 ? 'Vælg personer først' : ''
    }
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': _vm.selectedEmploymentIds.length === 0
    },
    attrs: {
      "disabled": _vm.selectedEmploymentIds.length === 0
    },
    on: {
      "click": _vm.openBulkCreate
    }
  }, [_vm._v("\n        Opret faste tillæg\n      ")])]), _vm._v(" "), _c('DDropdown', {
    attrs: {
      "isBottomStart": true,
      "isShowDots": false,
      "propOffset": [0, 8]
    }
  }, [_c('button', {
    staticClass: "do-bttn",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        Beregn tillæg automatisk "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "beregn-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.visibleBeregnOptions), function(option) {
    return _c('li', {
      key: option.id,
      on: {
        "click": function($event) {
          return _vm.selectBeregnOption(option)
        }
      }
    }, [_vm._v("\n          " + _vm._s(option.label) + "\n        ")])
  }), 0)]), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.cancelBatchMode
    }
  }, [_vm._v("Annuller valg")]) : _vm._e(), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('span', {
    staticClass: "faste-tillaeg__count"
  }, [_vm._v("\n      " + _vm._s(_vm.selectedEmploymentIds.length) + " valgt\n    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "faste-tillaeg__body"
  }, [(_vm.isLoadingEmployments) ? _c('Loader') : (_vm.viewTab === 'opus') ? _c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "td-check do-table__toggle-all",
    on: {
      "click": _vm.toggleAllSelected
    }
  }, [_c('div', {
    staticClass: "do-checkbox",
    class: {
      'do-checkbox--selected': _vm.isAllFilteredSelected
    }
  })]), _vm._v(" "), _c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("ANSÆTTELSE")]), _vm._v(" "), _c('th', [_vm._v("ORGANISATION")]), _vm._v(" "), _c('th', {
    staticClass: "th-actions"
  })])]), _vm._v(" "), (_vm.filteredRows.length === 0) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": 5
    }
  }, [_vm._v("Ingen ansættelser fundet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedRows), function(group) {
    return _c('tbody', {
      key: group.userId,
      staticClass: "user-group"
    }, _vm._l((group.rows), function(row) {
      return _c('tr', {
        key: row.id,
        staticClass: "fast-tillaeg-row",
        class: {
          'is-selected': _vm.isRowSelected(row)
        },
        on: {
          "click": function($event) {
            return _vm.onRowClick(row)
          }
        }
      }, [_c('td', {
        staticClass: "td-check",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.onCheckboxClick(row)
          }
        }
      }, [_c('div', {
        staticClass: "do-checkbox",
        class: {
          'do-checkbox--selected': _vm.isRowSelected(row)
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "bold"
      }, [_vm._v(_vm._s(row.userName))]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v("\n          " + _vm._s(row.employmentNumber) + " - " + _vm._s(row.employmentTitle) + "\n        ")]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v(_vm._s(row.organisation))]), _vm._v(" "), _c('td', {
        staticClass: "td-actions"
      }, [(!_vm.isBatchMode) ? _c('button', {
        staticClass: "do-bttn do-bttn--small row-action-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.openSingleCreate(row)
          }
        }
      }, [_vm._v("Opret fast tillæg")]) : _vm._e()])])
    }), 0)
  })], 2) : [_c('div', {
    staticClass: "faste-tillaeg__outbox-bar"
  }, [_c('span', {
    staticClass: "faste-tillaeg__outbox-info"
  }, [(_vm.isLoadingOutbox) ? [_vm._v("Indlæser…")] : (_vm.viewTab === 'sent') ? [_vm._v("\n            Afsendte og godkendte tillæg i OPUS. Klik på \"Opdater\"-knappen for at se den aktuelle status.\n          ")] : [_vm._v("\n            Tillæg i udbakken behandles løbende af OPUS. Klik på \"Opdater\"-knappen for at se den aktuelle status.\n          ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--small",
    attrs: {
      "disabled": _vm.isLoadingOutbox
    },
    on: {
      "click": _vm.loadOutbox
    }
  }, [_vm._v("\n          Opdater\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--small",
    class: {
      'do-bttn--loading': _vm.isDownloadingOutbox
    },
    attrs: {
      "disabled": _vm.isLoadingOutbox || _vm.isDownloadingOutbox || _vm.currentOutboxRows.length === 0
    },
    on: {
      "click": _vm.downloadOutboxExcel
    }
  }, [_vm._v("\n          Download til excel\n        ")])]), _vm._v(" "), (_vm.isLoadingOutbox) ? _c('Loader') : _c('table', {
    staticClass: "do-table do-table--striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "sortable td-created",
    on: {
      "click": function($event) {
        return _vm.sortOutbox('created_at')
      }
    }
  }, [_vm._v("OPRETTET "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    on: {
      "click": function($event) {
        return _vm.sortOutbox('user')
      }
    }
  }, [_vm._v("NAVN "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    on: {
      "click": function($event) {
        return _vm.sortOutbox('employment')
      }
    }
  }, [_vm._v("ANSÆTTELSE "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable td-loenkode",
    on: {
      "click": function($event) {
        return _vm.sortOutbox('loenkode')
      }
    }
  }, [_vm._v("LØNKODE "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable td-units",
    on: {
      "click": function($event) {
        return _vm.sortOutbox('antal')
      }
    }
  }, [_vm._v("ENHEDER "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable td-units",
    on: {
      "click": function($event) {
        return _vm.sortOutbox('beloeb')
      }
    }
  }, [_vm._v("BELØB "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable td-date",
    on: {
      "click": function($event) {
        return _vm.sortOutbox('fra')
      }
    }
  }, [_vm._v("FRA "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable td-date",
    on: {
      "click": function($event) {
        return _vm.sortOutbox('til')
      }
    }
  }, [_vm._v("TIL "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    on: {
      "click": function($event) {
        return _vm.sortOutbox('operation')
      }
    }
  }, [_vm._v("HANDLING "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    on: {
      "click": function($event) {
        return _vm.sortOutbox('created_by')
      }
    }
  }, [_vm._v("OPRETTET AF "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable td-status",
    on: {
      "click": function($event) {
        return _vm.sortOutbox('state')
      }
    }
  }, [_vm._v("STATUS "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), (_vm.viewTab === 'outbox') ? _c('th', {
    staticClass: "th-actions"
  }) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.currentOutboxRows.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": _vm.viewTab === 'outbox' ? 12 : 11
    }
  }, [_vm._v("\n            " + _vm._s(_vm.viewTab === 'sent' ? 'Ingen afsendte ændringer' : 'Ingen afventende ændringer i udbakken') + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.currentOutboxRows), function(row) {
    return _c('tr', {
      key: row.vRowKey,
      staticClass: "outbox-row"
    }, [_c('td', {
      staticClass: "td-created"
    }, [_vm._v(_vm._s(row.vCreatedAt))]), _vm._v(" "), _c('td', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(row.vUserName))]), _vm._v(" "), _c('td', {
      staticClass: "td-organisation"
    }, [_vm._v(_vm._s(row.vEmploymentLabel))]), _vm._v(" "), _c('td', {
      staticClass: "td-loenkode"
    }, [_vm._v(_vm._s(row.vLoenart))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.antal)))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.beloeb)))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(row.vFraDato))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(row.vTilDato))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.operationLabel(row.operation)))]), _vm._v(" "), _c('td', [(row.vCreatedByName) ? [_vm._v(_vm._s(row.vCreatedByName))] : (row.vCreatedById != null) ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'top',
          animateFill: false,
          animation: 'shift-away',
          boundary: 'window'
        }),
        expression: "{\n                    arrow: true,\n                    placement: 'top',\n                    animateFill: false,\n                    animation: 'shift-away',\n                    boundary: 'window'\n                  }"
      }],
      staticClass: "italic",
      attrs: {
        "content": 'Bruger-id: ' + row.vCreatedById
      }
    }, [_vm._v("\n              Tidligere ansat\n            ")]) : [_vm._v("—")]], 2), _vm._v(" "), _c('td', {
      staticClass: "td-status"
    }, [_c('span', {
      staticClass: "do-pill do-pill--small",
      class: _vm.statePillClass(row)
    }, [_vm._v("\n              " + _vm._s(_vm.stateLabel(row)) + "\n            ")]), _vm._v(" "), _vm._l((_vm.resultMessages(row)), function(msg, i) {
      return _c('div', {
        key: i,
        staticClass: "outbox-msg",
        class: {
          'outbox-msg--error': msg.type === 'E'
        }
      }, [_vm._v("\n              " + _vm._s(msg.code) + ": " + _vm._s(msg.text) + "\n            ")])
    })], 2), _vm._v(" "), (_vm.viewTab === 'outbox') ? _c('td', {
      staticClass: "td-actions"
    }, [(row.state === 'failed') ? _c('button', {
      staticClass: "do-bttn do-bttn--small do-bttn--danger",
      attrs: {
        "disabled": _vm.deletingIds.includes(row.id)
      },
      on: {
        "click": function($event) {
          return _vm.deleteFailedRow(row)
        }
      }
    }, [_vm._v("\n              Slet\n            ")]) : _vm._e()]) : _vm._e()])
  })], 2)])]], 2), _vm._v(" "), (_vm.activeRow) ? _c('FasteTillaegModal', {
    attrs: {
      "schoolId": _vm.schoolId,
      "employmentId": _vm.activeRow.employmentId,
      "employment": _vm.activeRow.employment,
      "userName": _vm.activeRow.userName
    },
    on: {
      "close": function($event) {
        _vm.activeRow = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.createEmploymentIds.length > 0) ? _c('CreateFastTillaeg', {
    attrs: {
      "schoolId": _vm.schoolId,
      "employmentIds": _vm.createEmploymentIds,
      "subtitle": _vm.createSubtitle
    },
    on: {
      "created": _vm.onBulkCreated,
      "close": _vm.closeCreate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowTidsbegraenset) ? _c('TidsbegraensetUvModal', {
    on: {
      "created": function($event) {
        _vm.isShowTidsbegraenset = false
      },
      "close": function($event) {
        _vm.isShowTidsbegraenset = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rowToDelete) ? _c('DModal', {
    staticStyle: {
      "z-index": "12312312312313"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        _vm.rowToDelete = null
      }
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal--small",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Slet linje")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        _vm.rowToDelete = null
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('p', [_vm._v("Er du sikker på, at du vil slette denne fejlede linje fra udbakken? Handlingen kan ikke fortrydes.")])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__child"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.rowToDelete = null
      }
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--danger",
    class: {
      'do-bttn--submit--loading': _vm.deletingIds.includes(_vm.rowToDelete.id)
    },
    attrs: {
      "disabled": _vm.deletingIds.includes(_vm.rowToDelete.id)
    },
    on: {
      "click": _vm.confirmDeleteFailedRow
    }
  }, [_vm._v("\n            Slet linje\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.isShowBeregnModal) ? _c('DModal', {
    staticStyle: {
      "z-index": "12312312312313"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": _vm.closeBeregnModal
    }
  }, [_c('div', {
    staticClass: "beregn-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "beregn-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.beregnModalTitle))]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle beregn-modal__close",
    on: {
      "click": _vm.closeBeregnModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "beregn-modal__content"
  }, [_c('Supplements', {
    attrs: {
      "isInOpusModal": true,
      "beregningType": _vm.beregnType,
      "sendToOpusTrigger": _vm.sendToOpusTrigger
    },
    on: {
      "approveState": function($event) {
        _vm.opusApproveState = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.opusApproveState.canApprove) ? _c('div', {
    staticClass: "beregn-modal__footer"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'top',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window',
        onShow: function () { return _vm.sendToOpusTooltip !== ''; }
      }),
      expression: "{\n                arrow: true,\n                placement: 'top',\n                animateFill: false,\n                animation: 'shift-away',\n                boundary: 'window',\n                onShow: () => sendToOpusTooltip !== ''\n              }"
    }],
    staticClass: "send-to-opus-wrap",
    attrs: {
      "content": _vm.sendToOpusTooltip
    }
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.opusApproveState.isApproving,
      'do-bttn--submit--disabled': _vm.opusApproveState.count === 0 || _vm.opusApproveState.missingEmployment
    },
    attrs: {
      "disabled": _vm.opusApproveState.isApproving || _vm.opusApproveState.count === 0 || _vm.opusApproveState.missingEmployment
    },
    on: {
      "click": _vm.triggerSendToOpus
    }
  }, [_vm._v("\n            Send til OPUS\n          ")])])]) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1eab22a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/KMD/FasteTillaeg.vue
// module id = 1793
// module chunks = 1